import { render, staticRenderFns } from "./WhatsHappeningNextEntries.vue?vue&type=template&id=1460567c&"
import script from "./WhatsHappeningNextEntries.vue?vue&type=script&lang=js&"
export * from "./WhatsHappeningNextEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports